import { Controller } from "@hotwired/stimulus";

// Immediate feedback for server-rendered (full page reload / Turbo) pagination.
// Clicking Next/Previous on a long list triggers a navigation that can take
// 1-3s to come back; with no feedback users think the click was ignored and
// rage-click (a top failure pattern in report session replays). On click we
// dim + lock the pager and swap the clicked Next/Prev arrow for a spinner. The
// page replace on navigation tears this down, so the state clears naturally
// once the next page paints.
//
// Wired onto the shared Kaminari paginator (app/views/kaminari/_paginator),
// so every server-side paginated list gets it.
export default class extends Controller {
  navigate(event) {
    const link = event.target.closest("a.item");
    // Active (current page) and disabled items don't navigate — ignore them.
    if (
      !link ||
      link.classList.contains("active") ||
      link.classList.contains("disabled")
    ) {
      return;
    }

    // Lock the whole pager so repeat clicks don't queue extra page loads.
    this.element.classList.add("pagination-navigating");

    // Show a spinner in place of the Next/Prev arrow (page-number links have
    // no icon — the dimmed pager is their feedback).
    const icon = link.querySelector("i.icon");
    if (icon) {
      icon.className = "notched circle loading icon";
    } else {
      link.classList.add("loading");
    }
  }
}
